import React from "react";
import { Link } from "react-router-dom";

const AboutSnapshot = () => {
  // Define client logos
  const clientLogos = [
    { name: "C3 AI", logo: "/assets/logos/c3ai.svg" },
    {
      name: "AWS",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Amazon_Web_Services_Logo.svg/320px-Amazon_Web_Services_Logo.svg.png",
    },
    {
      name: "PwC",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/PricewaterhouseCoopers_Logo.svg/220px-PricewaterhouseCoopers_Logo.svg.png",
    },
    {
      name: "Slalom",
      logo: "https://upload.wikimedia.org/wikipedia/commons/a/ae/Slalom_Consulting_Logo.svg",
    },
    {
      name: "Microsoft",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Microsoft_logo_%282012%29.svg/320px-Microsoft_logo_%282012%29.svg.png",
    },
    {
      name: "Cerner",
      logo: "https://upload.wikimedia.org/wikipedia/commons/3/3f/2011.Cerner.logo.png",
    },
  ];

  return (
    <section className="py-20 bg-dark relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute top-0 -left-32 w-96 h-96 bg-accent/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-accent/10 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* About text section */}
          <div className="space-y-6">
            <h2 className="text-3xl md:text-4xl font-bold text-light">
              About <span className="text-accent">Eluno Consulting</span>
            </h2>

            <p className="text-light/80 text-lg leading-relaxed">
              Eluno Consulting, led by Brad Wilde, provides tailored strategic
              advisory and technology consulting services, empowering leaders
              and entrepreneurs to confidently plan, prioritize, and execute
              complex initiatives.
            </p>

            <p className="text-light/80 text-lg leading-relaxed">
              With expertise in AI, digital transformation, healthcare, and
              public sector innovation, Brad delivers clear strategies and
              measurable outcomes.
            </p>

            <div className="pt-6">
              <Link
                to="/about"
                className="inline-flex items-center text-accent hover:text-accent/80 transition-colors duration-300"
              >
                <span className="font-medium">
                  Learn more about Brad's professional background
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 ml-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </Link>
            </div>
          </div>

          {/* Client logos section */}
          <div className="space-y-8">
            <h3 className="text-2xl font-semibold text-light">
              Career Background
            </h3>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
              {clientLogos.map((client, index) => (
                <div
                  key={index}
                  className="bg-dark/50 border border-light/10 rounded-lg p-4 flex items-center justify-center hover:border-accent/30 transition-colors duration-300"
                >
                  <img
                    src={client.logo}
                    alt={`${client.name} logo`}
                    className="h-8 md:h-10 max-w-full object-contain filter brightness-0 invert opacity-80 hover:opacity-100 transition-opacity duration-300"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSnapshot;
